import React from 'react'
import CustomImage from './CustomImage'
import Zoom from 'react-medium-image-zoom'

export default function NewTopAdmits({list}) {
    const topAdmits =list?list: [
        "/students/NewStudents2021-2022/Seher_Taneja_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-14.jpg",
        "/students/NewStudents2021-2022/Shreya_Tuli_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-01.jpg",
        "/students/NewStudents2021-2022/Satyam_Mehta_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-10.jpg",
        "/students/NewStudents2021-2022/Ananya_Gupta_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-18.jpg",
        "/students/NewStudents2021-2022/Divyansh_Aggarwal_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-19.jpg",
        "/students/NewStudents2021-2022/Advaita_Sood_Acceptance_2022_A4_Poster_for_Collegify_Delhi_Office_-_JPG_-_15_06_2022-02.jpg",
        "/students/NewStudents2021-2022/Vrinda_Periwal_Top_Admit_Card_of_Collegify_Delhi_-_2023-01.jpg",
        "/students/NewStudents2021-2022/Akshat_Gupta_Top_Admit_Card_of_Collegify_Delhi_-_2023-02.jpg",
        "/students/NewStudents2021-2022/Aishani_Mohan_Top_Admit_Card_of_Collegify_Delhi_-_2023-03.jpg",
        "/students/NewStudents2021-2022/Kasak_Jain_Top_Admit_Card_of_Collegify_Delhi_-_2023-04.jpg",
    ]
  return (
    <>
        
        <section className="container-fluid pt-5 px-0">
        <h2 className="text-primary text-center fw-bold mb-0">Top Admits</h2>
        <div className='colored-line line-center'></div>
            <div className='card border-0 shadow-none bg-secondary py-5 mt-4'>
                <div className="card-body p-0">
                    <div className="ticker-container">
                        <div className="ticker flex-row m-0">
                            {
                                [...Array(2)].map((_, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            topAdmits.map((student,key)=>(
                                                <div className="top-student-card h-auto border-0" key={key}>
                                                    <div className="card-body p-0">
                                                        <Zoom>
                                                            <CustomImage srcSetPaths={[{path: `${student}?tr=w-488,f-avif`, type: 'image/avif'},
                                                            {path: `${student}?tr=w-488,f-auto`, type: 'image/webp'}]}
                                                            mainSrc={`${student}?tr=w-488,f-png`} alt="" width="288" height="408" className="ak-img" imgCDN />
                                                        </Zoom>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
